
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibition/comment",
      function () {
        return require("private-next-pages/exhibition/comment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibition/comment"])
      });
    }
  